import { FETCH_PARTNER_DATA_SUCCESS } from "app/reducers/partnerActionTypes";

const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case FETCH_PARTNER_DATA_SUCCESS: {
			return action?.res?.data?.miles || INITIAL_STATE;
		}
		default:
			return state;
	}
};
